import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './BtnMenu.styles.scss'

const BtnMenu = ({ isActive, onClick }) => {
  const handleOnClick = () => {
    onClick()
  }

  return (
    <button
      type="button"
      className={styles.BtnMenu}
      aria-label="Toggle Menu"
      onClick={handleOnClick}
      data-active={isActive}
    >
      <div className={styles.menu}>
        <div className={styles.line} />
        <div className={styles.line} />
        <div className={styles.line} />
      </div>
    </button>
  )
}

BtnMenu.defaultProps = {
  isActive: false,
  onClick: () => {},
}

BtnMenu.propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
}

export { BtnMenu }
